import { extendTheme, theme } from "@chakra-ui/react";

export const newTheme = extendTheme({
  colors: { orange: { "50": "#fb972e" } },
  shadows: { ...theme.shadows, outline: "0 !important" },

  styles: {
    global: {
      body: {
        fontFamily: null,
        lineHeight: null,
      },
    },
  },
});
